(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ironpeak-bagtag-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ironpeak-bagtag-personalization')) {
customElements.define('ironpeak-bagtag-personalization', class extends HTMLElement {
connectedCallback() {
this.controller = new AbortController();
this.form = this.querySelector('input').form;
if (!this.form) return;
this.section = this.closest('.shopify-section') || this.form;
this.sync = () => {
const picker = this.section.querySelector('variant-picker');
const selected = picker?.querySelector('input:checked');
const selectedLabel = selected?.closest('label')?.textContent || '';
const pair = selectedLabel.includes('Pair') || this.form.querySelector('input[name="id"]')?.value === this.dataset.pairVariant;
const second = this.querySelector('[data-ornament="2"]');
second.hidden = !pair;
second.querySelectorAll('input, select').forEach(input => { input.disabled = !pair; input.required = pair && !input.hasAttribute("data-optional"); });
};
this.section.addEventListener('change', this.sync, { signal:this.controller.signal });
this.form.addEventListener('submit', event => {
this.sync();
this.querySelectorAll('input[type="text"]').forEach(input => { input.value = input.value.trim(); });
if (!this.form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
}, { capture:true, signal:this.controller.signal });
this.form.addEventListener('click', this.sync, { capture:true, signal:this.controller.signal });
this.observer = new MutationObserver(this.sync);
this.observer.observe(this.form, { subtree:true, attributes:true, attributeFilter:['value'] });
this.sync();
}
disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ironpeak-penguin-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ironpeak-penguin-personalization')) {
customElements.define('ironpeak-penguin-personalization', class extends HTMLElement {
connectedCallback() {
this.controller = new AbortController();
this.form = this.querySelector('input').form;
if (!this.form) return;
this.section = this.closest('.shopify-section') || this.form;
this.sync = () => {
const picker = this.section.querySelector('variant-picker');
const selected = picker?.querySelector('input:checked');
const selectedLabel = selected?.closest('label')?.textContent || '';
const pair = selectedLabel.includes('Pair') || this.form.querySelector('input[name="id"]')?.value === this.dataset.pairVariant;
const second = this.querySelector('[data-ornament="2"]');
second.hidden = !pair;
second.querySelectorAll('input, select').forEach(input => { input.disabled = !pair; input.required = pair; });
};
this.section.addEventListener('change', this.sync, { signal:this.controller.signal });
this.form.addEventListener('submit', event => {
this.sync();
this.querySelectorAll('input[type="text"]').forEach(input => { input.value = input.value.trim(); });
if (!this.form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
}, { capture:true, signal:this.controller.signal });
this.form.addEventListener('click', this.sync, { capture:true, signal:this.controller.signal });
this.observer = new MutationObserver(this.sync);
this.observer.observe(this.form, { subtree:true, attributes:true, attributeFilter:['value'] });
this.sync();
}
disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
});
}
  } catch(e) { console.error(e); }
})();

})();
